export default "__VITE_ASSET__e$AnN99R__"